import { apiSlice } from '../../../store/api/apiSlice';
import type {
  BookingSeriesOptionsRequest,
  BookingSeriesOptionsResponse,
  BookSeriesRequest,
  BookSeriesResponse,
} from '../types';

export const adminBookSeriesApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getBookingSeriesOptions: builder.query<
      BookingSeriesOptionsResponse,
      BookingSeriesOptionsRequest
    >({
      query: ({ coachPersonId, memberPersonId, month, startDate, weeks }) => {
        const params: Record<string, string | number> = {
          coach_person_id: coachPersonId,
          member_person_id: memberPersonId,
        };
        if (month) {
          params.month = month;
        }
        if (startDate) {
          params.start_date = startDate;
        }
        if (weeks) {
          params.weeks = weeks;
        }
        return { url: '/admin/booking-series/options', params };
      },
      providesTags: ['CalendarSettings'],
    }),
    bookSeries: builder.mutation<BookSeriesResponse, BookSeriesRequest>({
      query: (body) => ({ url: '/admin/booking-series', method: 'POST', body }),
      invalidatesTags: ['CalendarSettings'],
    }),
  }),
});

export const { useBookSeriesMutation, useGetBookingSeriesOptionsQuery } = adminBookSeriesApi;
